// Companion/blocks/StudySetLeaveModal.tsx
//
// The one interruption in the launch flow (ORA-681): the student already has a
// session open, and starting this one leaves it. There is no queueing — the old
// session stays exactly where it is and can be resumed from where it lives —
// so the choice is only "go" or "stay".

import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@/components/ui/modal';
import { Button } from '@/components/ui/button';

export interface StudySetLeaveModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const StudySetLeaveModal = ({
  open,
  onConfirm,
  onCancel,
}: StudySetLeaveModalProps) => (
  <Modal
    open={open}
    onClose={onCancel}
    name="study-set-leave"
    size="sm"
    ariaLabel="Leave this session?"
  >
    <ModalHeader>
      <h2>Leave this session?</h2>
    </ModalHeader>
    <ModalBody>
      <p className="!m-0 text-sm text-fg-secondary">
        Your current session will be left where it is and the new one will
        start.
      </p>
    </ModalBody>
    <ModalFooter>
      <div className="flex w-full flex-col-reverse gap-2 mobile:flex-row mobile:justify-end">
        <Button
          className="min-h-11 w-full mobile:w-auto"
          onClick={onCancel}
          type="button"
          variant="outline"
        >
          Stay
        </Button>
        <Button
          className="min-h-11 w-full mobile:w-auto"
          onClick={onConfirm}
          type="button"
        >
          Leave and Start
        </Button>
      </div>
    </ModalFooter>
  </Modal>
);

export default StudySetLeaveModal;
